import { render, staticRenderFns } from "./InformationCard.vue?vue&type=template&id=471716cc&scoped=true"
import script from "./InformationCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./InformationCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./InformationCard.vue?vue&type=style&index=0&id=471716cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471716cc",
  null
  
)

export default component.exports